export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20soft%20overlapping%20circles%20and%20organic%20shapes%20in%20terracotta%20peach%20and%20sage%2C%20subtle%20grid%20lines%20suggesting%20spreadsheet%20structure%2C%20minimalist%20modern%20design%20aesthetic%2C%20gentle%20diffused%20light%2C%20sophisticated%20brand%20presentation%20backdrop%2C%20clean%20and%20airy%20composition%20with%20artistic%20geometric%20elements&width=1600&height=800&seq=cta-bg-wide-v2&orientation=landscape"
          alt="Get the OOPBuy spreadsheet now"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative z-10 mx-auto px-6 md:px-10 max-w-7xl">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight">
              get the oopbuy
              <br />
              spreadsheet now
            </h2>
          </div>
          <div className="lg:text-right">
            <p className="text-base md:text-lg text-white/80 max-w-md leading-relaxed">
              compare thousands of products instantly
              <br />
              using our curated buying lists
            </p>
          </div>
        </div>

        <div className="mt-12">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 bg-white text-foreground-900 rounded-full text-base font-bold hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap group"
          >
            buy it now
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-900 text-white group-hover:bg-primary-500 transition-colors">
              <i className="ri-arrow-right-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}